import cn from "classnames";
import { type ReactNode, useRef } from "react";
import {
	Tooltip,
	TooltipContent,
	TooltipTrigger,
} from "@/components/ui/tooltip";
import { useEventSubscription } from "@/hooks/useEventSubscription";
import { EVENTS } from "@/shared/eventEmiters/consts";
import type { EventEmitter } from "@/shared/eventEmiters/EventEmitter";
import type { ViewId } from "@/shared/types/common";
import { Button } from "./button";

export const ExpandButton = ({
	content,
	id,
	className,
	eventEmitter,
	onClick,
}: {
	content: string | ReactNode;
	id: ViewId;
	className?: string;
	eventEmitter: EventEmitter;
	onClick?: () => void;
}) => {
	const isWindowExpandedRef = useRef<boolean>(false);

	useEventSubscription(
		eventEmitter,
		EVENTS.EXPANDED_WINDOW,
		(newState: boolean) => {
			isWindowExpandedRef.current = newState;
		},
	);

	return (
		<Button
			className={cn(
				"h-fit !p-0 rounded-sm font-bold transition-none",
				className,
			)}
			variant="filter"
			onClick={() => {
				if (onClick) onClick();
				eventEmitter.emit(EVENTS.EXPANDED_WINDOW, !isWindowExpandedRef.current);
			}}
		>
			<Tooltip>
				<TooltipTrigger asChild>{content}</TooltipTrigger>
				<TooltipContent>
					{id === "Monitor" ? "Columns" : "Filters"}
				</TooltipContent>
			</Tooltip>
		</Button>
	);
};
